import { zodResolver } from '@hookform/resolvers/zod';
import React, { FC, useContext, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { z } from 'zod';

import HeadingText from '@ui/atoms/HeadingText';

import TextArea from '@ui/forms/TextArea';

import BackAndNextNav from '@ui/molecules/BackAndNextNav';
import SpacedGridItem from '@ui/molecules/SpacedGridItem';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepComponentProps } from '@folx-types/flow-steps';

import { dataConstants, schema } from './AdditionalInfoStep.data';

export interface IMemberHRTAdditionalInfoStepPageContent {
	heading: string;
	label: string;
	inputPlaceholder: string;
}

interface IAdditionalInfoStepProps extends IFlowStepComponentProps {
	pageContent: IMemberHRTAdditionalInfoStepPageContent;
}

const AdditionalInfoStep: FC<IAdditionalInfoStepProps> = ({ stepKey, pageContent }) => {
	console.log('AdditionalInfoStep');

	const { heading, label, inputPlaceholder } = pageContent;

	type Schema = Partial<z.input<typeof schema>>;

	const [submitting, setSubmitting] = useState(false);

	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	const {
		handleSubmit,
		control,
		register,
		formState: { errors, isSubmitted },
	} = useForm<Schema>({
		defaultValues: {
			[dataConstants.ADDITIONAL_APPT_INFO]: existingFormData?.additional_appt_info ?? '',
		},
		resolver: zodResolver(schema),
		mode: 'onChange',
	});

	const onSubmit = async (data: Record<string, unknown>) => {
		setSubmitting(true);
		await handleFormSubmission(data, stepKey);
		setSubmitting(false);
	};

	return (
		<>
			<SpacedGridItem marginBottom="lgxl">
				<HeadingText>{heading}</HeadingText>
			</SpacedGridItem>
			<SpacedGridItem marginBottom="lgxl">
				<form onSubmit={handleSubmit(onSubmit)}>
					<Controller
						name={dataConstants.ADDITIONAL_APPT_INFO}
						control={control}
						render={({ field }) => (
							<TextArea
								{...field}
								label={label}
								placeholder={inputPlaceholder}
								name={dataConstants.ADDITIONAL_APPT_INFO}
								error={isSubmitted && !!errors[dataConstants.ADDITIONAL_APPT_INFO]}
								errorLabel={
									!!errors[dataConstants.ADDITIONAL_APPT_INFO] &&
									errors[dataConstants.ADDITIONAL_APPT_INFO]?.message
								}
							/>
						)}
					/>
					<BackAndNextNav
						marginTop="xxl"
						submitLabel="Next"
						submitting={submitting}
						backOnClick={() => handleNavBack(stepKey)}
					/>
				</form>
			</SpacedGridItem>
		</>
	);
};

export default AdditionalInfoStep;
